import { createGlobalStyle } from "styled-components";
import { appNeutralPalette } from "./theme/v6/palette";

import "./fonts/fonts.css";

const GlobalStyle = createGlobalStyle`

  /* Фон раннего Suspense, пока тематический App AntD ещё не смонтирован. */
  html, body, #root {
    background: ${appNeutralPalette[1]};
  }

  html[data-theme="dark"],
  html[data-theme="dark"] body,
  html[data-theme="dark"] #root {
    background: ${appNeutralPalette[9]};
  }

  html[data-theme="light"] {
    color-scheme: light;
  }

  html[data-theme="dark"] {
    color-scheme: dark;
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

  }

  #root {
    min-height: 100vh;
    display: flex;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

`;

export default GlobalStyle;
